
import React from "react";

const Logo = () => {
  return <a href="/" className="text-xl font-bold text-primary-content">Buy Product</a>;
};

export default Logo;
